import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ISBreadcrumbComponent } from './is-breadcrumb.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared.module';

const materialModules = [
    MatIconModule
];

@NgModule({
    declarations: [ISBreadcrumbComponent],
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,
        ...materialModules
    ],
    exports: [ISBreadcrumbComponent],
    providers: [],
})
export class ISBreadcrumbModule {}